import { useEffect, useState } from 'react';
import Select from 'react-select';
import { documentTypeRepository } from '../../../infrastructure/repositories/document-types/document-typesRepository';
import { BaseSelector } from '../../../domain/shared';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
}

export default function DocumentTypeSelector({ onChange, value, name }: Props) {
    const [documentTypes, setDocumentTypes] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        documentTypeRepository.GetDocumentTypeList().then((res) => {
            setIsLoading(false);
            setDocumentTypes(
                res.map((dt) => ({
                    label: dt.name,
                    value: dt.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Tipo de Documento *
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={documentTypes}
                onChange={(e) => {
                    onChange(name, e?.value);
                }}
                value={
                    documentTypes.find((a) => a.value === value) ?? {
                        label: `Seleccione`,
                        value: 0,
                    }
                }
            />
        </div>
    );
}
